import { useMemo, useState } from 'react';
import Page from '../../../components/PageWrapper';
import { ITablePaginationData } from '../../../components/elements/GTable/GTable';
import moment from 'moment';
import { FuelSalesStatus } from '../../../components/statuses';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import { getFuelVendorSalesHistory } from '../../../api/requests';
import useUserAccount from '../../../hooks/userAccountHook';
import { useQuery } from '@tanstack/react-query';
import Loader from '../../../components/Loader';
import { IUser } from '../../../models/User';
import { LuFuel } from 'react-icons/lu';
import { FaMoneyBillAlt } from 'react-icons/fa';
import { FUEL_SALES_STATUS } from '../../../resources/enums';
import { getFormattedSalesStatusFromKey, getStatusColor } from '../../../utils/miscFunctions';

const data = [
  {
    id: 100392,
    amount: 550,
    quantity: 36.19,
    salesMadeOn: '2024-06-25',
    status: 'CLOSED'
  },
  {
    id: 100392,
    amount: 550,
    quantity: 36.19,
    salesMadeOn: '2024-06-25',
    status: 'CLOSED'
  }
];
const FuelVendorSalesHistory = () => {
  const navigate = useNavigate();
  const { user } = useUserAccount();
  const [loading, setLoading] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState<number>(
    searchParams.get('page') ? Number(searchParams.get('page')) : 0
  );
  const [salesData, setSalesData] = useState<any[]>([]);
  const [salesPaginationData, setSalesPaginationData] = useState<ITablePaginationData>({
    total: 0,
    per_page: 0,
    totalPages: 0,
    initialPage: currentPage ? currentPage : 0,
    from: 0,
    to: 0
  });

  const columns = useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Date',
            accessor: 'salesMadeOn',
            Cell: (row: any) => (
              <span>{row.cell.value ? moment(row.cell.value).format('DD/MM/YY') : '-'}</span>
            )
          },
          {
            Header: 'Amount',
            accessor: 'amount',
            Cell: (row: any) => <span>{row.cell.value ? row.cell.value : '-'}</span>
          },
          {
            Header: 'Fuel (in LTRS)',
            accessor: 'quantity',
            Cell: (row: any) => <span>{row.cell.value ? row.cell.value : '-'}</span>
          },
          {
            Header: '',
            accessor: 'status',
            Cell: (row: any) => <FuelSalesStatus row={row} />
          }
        ]
      }
    ],
    []
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSearchParams({ page: String(page) });
  };

  const fetchSalesHistory = async () => {
    setLoading(true);
    try {
      const response = await getFuelVendorSalesHistory(user?.id);
      setSalesData(response);
      setSalesPaginationData({
        total: response.total ?? 0,
        per_page: response.per_page ?? 0,
        totalPages: Math.ceil(response.total / response.per_page),
        initialPage: currentPage ?? 0,
        from: response.from ?? 0,
        to: response.to ?? 0
      });
    } catch (error: any) {
      console.error('Error fetching sales history:', error);
    } finally {
      setLoading(false);
    }
  };

  useQuery({
    queryKey: ['fetchSalesHistory'],
    queryFn: fetchSalesHistory
  });

  return (
    <Page title="Sales">
      <div className="bg-white p-5 min-h-full">
        <div className="w-fit">
          <BackButton onClick={() => navigate(-1)} />
        </div>

        {/* <div>
          <GTable
            columns={columns}
            data={salesData ?? []}
            classes="h-fit"
            tableType="sale"
            onSearch={(searchString: string) => setSearchString(searchString)}
            showSearch={false}
            loading={loading}
            paginationData={salesPaginationData}
            onPageChange={handlePageChange}
            showPerPage={showPerPage}
            onShowPerPageChange={(page: number) => setShowPerPage(page)}
          />
        </div> */}

        {loading ? (
          <div className="w-full py-10 flex items-center justify-center h-full">
            <Loader message={`Loading sales. Please wait...`} brollyLoader />
          </div>
        ) : (
          <div className="min-h-full overflow-y-auto hideScrollBar py-5">
            <>
              {salesData && salesData?.length > 0 ? (
                <FuelSaleList sales={salesData} />
              ) : (
                <div className="w-full h-40 font-semibold min-h-full flex items-center justify-center">
                  No sale found
                </div>
              )}
            </>
          </div>
        )}
      </div>
    </Page>
  );
};

interface FuelSale {
  id: number;
  salesMadeOn: string;
  amount: number;
  quantity: number;
  status: FUEL_SALES_STATUS;
}
interface FuelSaleListProps {
  sales: FuelSale[];
}

export const FuelSaleList: React.FC<FuelSaleListProps> = ({ sales }: FuelSaleListProps) => {
  return (
    <div className=" w-full  shadow-md">
      {sales.map((sale) => (
        <div key={sale.id} className="flex items-center justify-between py-2 border-b">
          <div className="flex items-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white rounded">
              <FaMoneyBillAlt className="w-6 h-6" />
            </div>
            <div className="ml-4">
              <div className="text-sm font-semibold">GHC {sale.amount ?? '-'}</div>

              <div className="text-xs text-gray-500">
                {moment(sale.salesMadeOn).format('DD/MM/YY') ?? '-'}
              </div>
            </div>
          </div>

          <div className="text-right">
            <div className="text-sm font-semibold">{sale.quantity ? `${sale.quantity} L` : '-'} </div>
            <div className={`text-xs ${getStatusColor(sale.status)}`}>
              {getFormattedSalesStatusFromKey(sale.status) ?? '-'}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FuelVendorSalesHistory;
